import {Alert, Form, Input, notification, Select} from "@ui";
import PropTypes from "prop-types";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import {adapterBankList} from "../../../adapters/bankListAdapter";
import usePagoMovilRegistration from "../../../hooks/usePagoMovilRegistration";
import usePutUserPagoMovilRegistrationData from "../../../hooks/usePutUserPagoMovilRegistrationData.hook";
import useUpdateProfile from "../../../hooks/useUpdateProfile";
import useCreateAccPagoMovil from "../../../hooks/wallet/useCreateAccPagoMovil";
// [Disabled-edit-delete-pagoMovil] import {adapterBankList, findBankData} from "../../../adapters/bankListAdapter";
// [Disabled-edit-delete-pagoMovil] import useEditAccPagoMovil from "../../../hooks/wallet/useEditAccPagoMovil";
import styles from "./AddPagoMovil.module.css";

const AddPagoMovilForm = ({onSuccess, onCancel /* [Disabled-edit-delete-pagoMovil] isUpdate, data */}) => {
  const {mutate, isPending, isSuccess, isError, error} = useCreateAccPagoMovil();
  // [Disabled-edit-delete-pagoMovil] const {update, isPendingUpdate, isSuccessUpdate, isErrorUpdate, errorUpdate} = useEditAccPagoMovil();
  const {needsRegistration, userData, hasNationalID, hasPhoneNumber, executePendingAction} = usePagoMovilRegistration();

  const {
    putUserPagoMovilData,
    isPending: isPendingFullRegistration,
    isSuccess: isSuccessFullRegistration,
    error: errorFullRegistration,
  } = usePutUserPagoMovilRegistrationData();

  const {postUpdate, isPending: isPendingProfile, isSuccess: isSuccessProfile} = useUpdateProfile(() => {});

  const {t} = useTranslation();
  const [form] = Form.useForm();
  // [Disabled-edit-delete-pagoMovil] const [showConfirmOverlay, setShowConfirmOverlay] = useState(false);
  // [Disabled-edit-delete-pagoMovil] const [pendingFormValues, setPendingFormValues] = useState(null);

  const showFullRegistrationForm = needsRegistration;
  const needsFullRegistration = !hasNationalID || !hasPhoneNumber;
  // [Disabled-edit-delete-pagoMovil] const showFullRegistrationForm = !isUpdate && needsRegistration;

  useEffect(() => {
    if (errorFullRegistration) {
      const errorMessage = errorFullRegistration.message;
      if (errorMessage.includes("duplicated.attribute.nationalID")) {
        form.setFields([
          {
            name: "nationalID",
            errors: ["Este número de cédula ya está registrado."],
          },
        ]);
      } else if (errorMessage.includes("duplicated.attribute.phoneNumber")) {
        form.setFields([
          {
            name: "phoneNumber",
            errors: ["Este número de teléfono ya está registrado."],
          },
        ]);
      } else {
        notification.error({
          message: t("pagoMovilRegistrationErrorTitle") || "Error",
          description: "Hubo un error durante el registro. Por favor, inténtalo de nuevo.",
        });
      }
    }
  }, [errorFullRegistration, form, t]);

  useEffect(() => {
    if (isError && error) {
      const errorMessage = error?.response?.data?.message || error?.response?.data?.error || error?.message || "";

      notification.error({
        message: t("pagoMovilCreationErrorTitle") || "Error",
        description:
          errorMessage ||
          t("pagoMovilCreationErrorMessage") ||
          "No se pudo agregar la cuenta de pago móvil. Inténtalo de nuevo.",
      });
    }
  }, [isError, error, t]);

  // [Disabled-edit-delete-pagoMovil]
  // useEffect(() => {
  //   if (isErrorUpdate && errorUpdate) {
  //     const status = errorUpdate?.response?.status;
  //     const errorMessage =
  //       errorUpdate?.response?.data?.message || errorUpdate?.response?.data?.error || errorUpdate?.message || "";
  //
  //     notification.error({
  //       message: t("pagoMovilUpdateErrorTitle") || "Error",
  //       description:
  //         status === 404
  //           ? t("pagoMovilAccountNotFound") || "Esta cuenta ya no existe. La lista se actualizará."
  //           : errorMessage ||
  //             t("pagoMovilUpdateErrorMessage") ||
  //             "No se pudo actualizar la cuenta de pago móvil. Inténtalo de nuevo.",
  //     });
  //
  //     if (status === 404 && onCancel) {
  //       onCancel();
  //     }
  //   }
  // }, [isErrorUpdate, errorUpdate, t, onCancel]);

  useEffect(() => {
    return () => {
      form.resetFields();
    };
  }, [form]);

  useEffect(() => {
    // [Disabled-edit-delete-pagoMovil]
    // if (isUpdate && data?.bank_code != null) {
    //   const bankData = findBankData({bank_code: data.bank_code});
    //   const bankLabel = bankData?.bank_name ?? String(data.bank_code);
    //
    //   form.setFieldsValue({
    //     ID: data.ID,
    //     bank: {value: data.bank_code, label: bankLabel},
    //     phone: data.phone_number,
    //   });
    // } else
    if (showFullRegistrationForm && userData) {
      form.setFieldsValue({
        firstName: userData.given_name || userData.firstName || "",
        lastName: userData.family_name || userData.lastName || "",
        nationalID: userData.nationalID || "",
        phoneNumber: userData.phoneNumber || "",
        phone: userData.phoneNumber || "",
      });
    }
  }, [showFullRegistrationForm, userData, form /* [Disabled-edit-delete-pagoMovil] isUpdate, data */]);

  // [Disabled-edit-delete-pagoMovil]
  // const handleSubmit = values => {
  //   try {
  //     if (isUpdate) {
  //       setPendingFormValues(values);
  //       setShowConfirmOverlay(true);
  //       return;
  //     }
  //     executeSubmit(values);
  //   } catch (_error) {
  //     notification.error({
  //       message: "Error",
  //       description: "There was an error processing your request. Please try again.",
  //     });
  //   }
  // };

  const executeSubmit = values => {
    try {
      const fullNationalID = values.idPrefix ? `${values.idPrefix}${values.nationalID}` : values.nationalID;

      if (showFullRegistrationForm) {
        if (needsFullRegistration) {
          putUserPagoMovilData({
            firstName: values.firstName,
            lastName: values.lastName,
            nationalID: fullNationalID,
            phoneNumber: values.phoneNumber,
          });

          form.setFieldsValue({
            ...values,
            _bankForPagoMovil: values.bank,
            _phoneForPagoMovil: values.phoneNumber,
          });
        } else {
          const profileData = {
            firstName: values.firstName,
            lastName: values.lastName,
            nationalID: fullNationalID,
            phoneNumber: values.phoneNumber,
          };

          form.setFieldsValue({
            ...values,
            _bankForPagoMovil: values.bank,
            _phoneForPagoMovil: values.phoneNumber,
          });

          postUpdate(profileData);
        }
      } else {
        const bankCode = values.bank.value === undefined ? values.bank : values.bank.value;

        // [Disabled-edit-delete-pagoMovil]
        // if (isUpdate) {
        //   update({
        //     ID: values.ID,
        //     bank_code: Number(bankCode),
        //     phone_number: Number(values.phone),
        //   });
        // } else {
        mutate({
          bank_code: Number(bankCode),
          phone_number: Number(values.phone),
        });
        // }
      }
    } catch (_error) {
      notification.error({
        message: "Error",
        description: "There was an error processing your request. Please try again.",
      });
    }
  };

  // [Disabled-edit-delete-pagoMovil]
  // const handleConfirmUpdate = () => {
  //   setShowConfirmOverlay(false);
  //   executeSubmit(pendingFormValues);
  //   setPendingFormValues(null);
  // };
  //
  // const handleCancelUpdate = () => {
  //   setShowConfirmOverlay(false);
  //   setPendingFormValues(null);
  // };

  useEffect(() => {
    try {
      if ((isSuccessProfile || isSuccessFullRegistration) && showFullRegistrationForm) {
        const formValues = form.getFieldsValue();
        const bankCode = formValues._bankForPagoMovil?.value ?? formValues._bankForPagoMovil ?? formValues.bank;
        const phoneNumber = formValues._phoneForPagoMovil || formValues.phoneNumber;

        mutate({
          bank_code: Number(bankCode),
          phone_number: Number(phoneNumber),
        });
      }
    } catch (_error) {}
  }, [isSuccessProfile, isSuccessFullRegistration, showFullRegistrationForm, form, mutate]);

  useEffect(() => {
    try {
      // [Disabled-edit-delete-pagoMovil]
      // if (isSuccessUpdate) {
      //   notification.success({
      //     message: "Pago movil actualizado correctamente",
      //   });
      //   form.resetFields();
      //   if (onSuccess) {
      //     onSuccess();
      //   }
      // } else
      if (isSuccess && !showFullRegistrationForm) {
        notification.success({
          message: "Pago movil agregado correctamente",
        });
        form.resetFields();
        if (onSuccess) {
          onSuccess();
        }
      } else if (isSuccess && showFullRegistrationForm) {
        notification.success({
          message: t("pagoMovilRegistrationSuccessTitle") || "Registration Successful",
          description:
            t("pagoMovilRegistrationSuccessMessage") ||
            "Your personal information and Pago Móvil account have been registered successfully.",
        });
        form.resetFields();

        if (onSuccess) {
          onSuccess();
        }

        const timeoutId = setTimeout(async () => {
          try {
            if (executePendingAction && typeof executePendingAction === "function") {
              await executePendingAction();
            }
          } catch (_error) {}
        }, 300);

        return () => {
          clearTimeout(timeoutId);
        };
      }
    } catch (_error) {}
  }, [
    isSuccess,
    showFullRegistrationForm,
    t,
    onSuccess,
    form,
    executePendingAction /* [Disabled-edit-delete-pagoMovil] isSuccessUpdate */,
  ]);

  return (
    <>
      <Form
        form={form}
        onFinish={executeSubmit}
        layout="vertical"
      >
        {showFullRegistrationForm && (
          <Alert
            message={t("addPagoMovilExplanationTitle") || "Personal Registration Required"}
            description={t("addPagoMovilExplanationMessage")}
            type="warning"
            showIcon
            className={styles.registrationAlert}
          />
        )}

        {/* [Disabled-edit-delete-pagoMovil]
        {isUpdate && (
          <Form.Item
            name="ID"
            label="ID"
            hidden
          >
            <Input />
          </Form.Item>
        )}
        */}

        {showFullRegistrationForm && (
          <>
            <Form.Item
              name="firstName"
              label={t("name") || "Name"}
              rules={[
                {
                  required: true,
                  message: t("nameRequired") || "Name is required",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="lastName"
              label={t("lastName") || "Last Name"}
              rules={[
                {
                  required: true,
                  message: t("lastNameRequired") || "Last name is required",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item label={t("nationalID")}>
              <Input.Group compact>
                <Form.Item
                  name="idPrefix"
                  noStyle
                  initialValue="V-"
                >
                  <Select
                    style={{width: 50}}
                    className="id-prefix-select"
                  >
                    <Select.Option value="V-">V</Select.Option>
                    <Select.Option value="E-">E</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="nationalID"
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: t("nationalIDRequired") || "ID is required",
                    },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.resolve();
                        }

                        if (!/^\d+$/.test(value)) {
                          return Promise.reject(new Error("Only numbers are allowed"));
                        }

                        if (value.length < 7) {
                          return Promise.reject(
                            new Error(t("pagoMovilRegistrationCedulaMinLength") || "ID must have at least 7 digits")
                          );
                        }

                        if (value.length > 15) {
                          return Promise.reject(
                            new Error(t("pagoMovilRegistrationCedulaMaxLength") || "ID cannot have more than 15 digits")
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input style={{width: "calc(100% - 50px)"}} />
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item
              name="phoneNumber"
              label={t("phoneNumber") || "Phone Number"}
              rules={[
                {
                  required: true,
                  message: t("phoneNumberRequired") || "Phone number is required",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve();
                    }

                    if (!/^\d+$/.test(value)) {
                      return Promise.reject(new Error("Only numbers are allowed"));
                    }

                    if (value.length < 10) {
                      return Promise.reject(
                        new Error(t("phoneNumberMinLength") || "Phone number must have at least 10 digits")
                      );
                    }

                    if (value.length > 11) {
                      return Promise.reject(
                        new Error(t("phoneNumberMaxLength") || "Phone number cannot have more than 11 digits")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input />
            </Form.Item>
          </>
        )}

        <Form.Item
          name="bank"
          label={
            <span>
              {t("mobilePaymentModalBank")}
              <span style={{color: "var(--status-error)", marginLeft: "4px"}}>*</span>
            </span>
          }
          rules={[
            {
              required: true,
              message: t("mobilePaymentModalSelectBankMessage"),
            },
          ]}
          required={false}
        >
          <Select
            showSearch
            placeholder={t("mobilePaymentModalSelectBank")}
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {adapterBankList().map(item => (
              <Select.Option
                key={item.value}
                value={item.value}
              >
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {!showFullRegistrationForm && (
          <Form.Item
            name="phone"
            label={
              <span>
                {t("mobilePaymentModalPhone")}
                <span style={{color: "var(--status-error)", marginLeft: "4px"}}>*</span>
              </span>
            }
            rules={[
              {
                required: true,
                message: t("mobilePaymentModalPhonePlaceholderMessage"),
              },
            ]}
            required={false}
          >
            <Input placeholder={t("mobilePaymentModalPhonePlaceholder")} />
          </Form.Item>
        )}

        <Form.Item style={{marginBottom: 0}}>
          <div className="form-modal-footer">
            {onCancel && <SecondaryButton onClick={onCancel}>{t("cancel") || "Cancelar"}</SecondaryButton>}
            <PrimaryButton
              htmlType="submit"
              loading={isPending || isPendingProfile || isPendingFullRegistration}
              // [Disabled-edit-delete-pagoMovil] loading={isUpdate ? isPendingUpdate : isPending || isPendingProfile || isPendingFullRegistration}
            >
              {showFullRegistrationForm
                ? t("registerAndAddPagoMovil") || "Register & Add Mobile Payment"
                : t("mobilePaymentModalSubmitBtn")}
            </PrimaryButton>
          </div>
        </Form.Item>
      </Form>

      {/* [Disabled-edit-delete-pagoMovil]
      {showConfirmOverlay && (
        <div
          className={styles.confirmOverlay}
          onClick={handleCancelUpdate}
        >
          <div
            className={styles.confirmCard}
            onClick={e => e.stopPropagation()}
          >
            <span className={styles.confirmText}>
              {t("confirmSaveChanges") || "¿Estás seguro de que quieres guardar los cambios?"}
            </span>
            <div className="form-modal-footer">
              <SecondaryButton onClick={handleCancelUpdate}>{t("cancel") || "Cancelar"}</SecondaryButton>
              <PrimaryButton
                onClick={handleConfirmUpdate}
                loading={isPendingUpdate}
              >
                {t("accept") || "Aceptar"}
              </PrimaryButton>
            </div>
          </div>
        </div>
      )}
      */}
    </>
  );
};

AddPagoMovilForm.propTypes = {
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
  // [Disabled-edit-delete-pagoMovil] isUpdate: PropTypes.bool,
  // [Disabled-edit-delete-pagoMovil] data: PropTypes.object,
};

export default AddPagoMovilForm;
